'use strict'

// Built-in live-app themes. The files live in shared/vendor and are served
// from this app at /vendor. Nothing in this list is loaded from another host.

const THEMES = [
  { id: 'default', name: 'Default Bootstrap' },
  { id: 'cerulean', name: 'Cerulean' },
  { id: 'cosmo', name: 'Cosmo' },
  { id: 'darkly', name: 'Darkly' },
  { id: 'flatly', name: 'Flatly' },
  { id: 'journal', name: 'Journal' },
  { id: 'litera', name: 'Litera' },
  { id: 'lumen', name: 'Lumen' },
  { id: 'lux', name: 'Lux' },
  { id: 'materia', name: 'Materia' },
  { id: 'minty', name: 'Minty' },
  { id: 'pulse', name: 'Pulse' },
  { id: 'sandstone', name: 'Sandstone' },
  { id: 'simplex', name: 'Simplex' },
  { id: 'sketchy', name: 'Sketchy' },
  { id: 'slate', name: 'Slate' },
  { id: 'solar', name: 'Solar' },
  { id: 'spacelab', name: 'Spacelab' },
  { id: 'superhero', name: 'Superhero' },
  { id: 'united', name: 'United' },
  { id: 'yeti', name: 'Yeti' },
  { id: 'zephyr', name: 'Zephyr' }
]

function themeCssPath (id) {

  const theme = THEMES.find(item => item.id === id)

  return `/vendor/themes/${(theme || THEMES[0]).id}/bootstrap.min.css`
}

module.exports = {
  THEMES,
  themeCssPath
}
